module.exports = __webpack_public_path__ + "img/logo.b13c4440.png";